import React from 'react';
import { useController } from 'react-hook-form';
import { Form, Input } from 'antd';

const AntdTextarea = ({
  name,
  maxLength,
  rows,
  label,
  placeholder,
  prefix,
  showCount,
  validateStatus,
  errorMsg,
  control,
  className,
  defaultValue,
  setValue,
}) => {
  const { TextArea } = Input;
  const {
    // field: { ...inputProps }
    field
  } = useController({
    name,
    control
  }); 
  React.useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue);
    }
  }, [defaultValue]);

  return (
    <Form.Item
      label={label}
      help={errorMsg}
      validateStatus={validateStatus}
      colon={false}
    >
      <TextArea
        {...field}
        co
        rows={rows}
        showCount={showCount}
        maxLength={maxLength}
        placeholder={placeholder}
        prefix={prefix}
        className={className}
        defaultValue={defaultValue}
      />
    </Form.Item>
  );
};

export default AntdTextarea;
